import React from 'react';
import useBlockStyles from '../common/useBlockStyles';

const DIVIDER_STYLE_OPTIONS = { defaultBackground: 'transparent' };

/**
 * DividerRenderer - Render component for divider block
 */
const DividerRenderer = ({ block, theme = {} }) => {
  const { content } = block;
  const {
    dividerStyle = 'line',
    width = 'medium',
    spacing = 'normal',
    color = 'default',
  } = content;

  // Use the block style system for theme-resolved values
  const styles = useBlockStyles(content, theme, DIVIDER_STYLE_OPTIONS);

  const accent = styles.accentColor;
  const isDark = styles.isDark;

  // Dynamic color values based on theme
  const colorValues = {
    default: isDark ? '#4b5563' : '#9ca3af',
    accent: accent,
    subtle: isDark ? '#1f2937' : '#e5e7eb',
  };

  const spacingClasses = {
    compact: 'py-4 sm:py-6',
    normal: 'py-6 sm:py-8 md:py-10',
    large: 'py-10 sm:py-12 md:py-16',
  };

  const widthClasses = {
    narrow: 'max-w-xs',
    medium: 'max-w-md',
    wide: 'max-w-2xl',
    full: 'max-w-full',
  };

  // Spacer only - no visible line
  if (dividerStyle === 'space') {
    return (
      <div className={`w-full ${spacingClasses[spacing]} bg-transparent`} />
    );
  }

  // Gradient style
  if (dividerStyle === 'gradient') {
    const lineColor = colorValues[color] || colorValues.default;
    return (
      <div className={`w-full px-4 sm:px-6 ${spacingClasses[spacing]}`}>
        <div
          className={`${widthClasses[width]} mx-auto h-px`}
          style={{
            background: `linear-gradient(to right, transparent, ${lineColor}, transparent)`,
          }}
        />
      </div>
    );
  }

  // Line or dotted style
  const lineColor = colorValues[color] || colorValues.default;
  return (
    <div className={`w-full px-4 sm:px-6 ${spacingClasses[spacing]}`}>
      <div
        className={`${widthClasses[width]} mx-auto`}
        style={{
          borderTop: `1px ${dividerStyle === 'dotted' ? 'dotted' : 'solid'} ${lineColor}`,
        }}
      />
    </div>
  );
};

export default DividerRenderer;
